import { Link } from 'react-router-dom';

import './ArchivePage.css';

/*
 * The catch-all. Previously it redirected to /manager, which quietly
 * pretended the URL had been something else.
 */
export default function NotFoundPage() {
	return (
		<div className="archive-page notfound">
			<img
				className="notfound__gif"
				src="/static/img/fail.gif"
				alt=""
				width="304"
				height="228"
			/>

			<header className="archive-page__intro">
				<h1>Page not found</h1>
				<p className="archive-page__lede">
					That link does not point anywhere on the site. It may have moved, or a
					league may have been renamed.
				</p>
			</header>

			<ul className="leagues">
				<li>
					<Link className="league-pill" to="/">
						Home
					</Link>
				</li>
				<li>
					<Link className="league-pill" to="/ticker">
						Fixture ticker
					</Link>
				</li>
				<li>
					<Link className="league-pill" to="/history">
						Points archive
					</Link>
				</li>
			</ul>

			<p className="section-note">
				To add your league, tweet{' '}
				<a href="https://twitter.com/FPL_Nutmeg">@FPL_Nutmeg</a>.
			</p>
		</div>
	);
}
